import enLang from './entries/en_US';
import frLang from './entries/fr_FR';
import ArLang from './entries/ar_EG';
import DBLang from './entries/db_DB';

const AppLocale = {
    en: enLang,
    fr: frLang,
    ar: ArLang,
    db: DBLang
};

export default AppLocale;